import { Mapper } from "../../../../base/utils/mapper";
import { LocationModel } from "../../../../domain/models/thirdparty/location.model";
import { LocationEntity } from "../entities/location.entity";


export class LocationImplementationRepositoryMapper extends Mapper<LocationEntity, LocationModel> {
    mapFrom(param: LocationEntity): LocationModel {
        return {
            ip: param.ip,
            ip_number: param.ip_number,
            ip_version:param.ip_version,
            country_name: param.country_name,
            country_code2:param.country_code2,
            isp:param.isp,
            response_code: param.response_code,
            response_message: param.response_message
        };
    }
    mapTo(param: LocationModel): LocationEntity {
        return {
            ip: param.ip,
            ip_number: param.ip_number,
            ip_version:param.ip_version,
            country_name: param.country_name,
            country_code2:param.country_code2,
            isp:param.isp,
            response_code: param.response_code,
            response_message: param.response_message
        }
    }
}